const initialState = {
  editingUser: null,
};

const editUser = (state = initialState, action) => {
  switch (action.type) {
    case 'EDIT_USER':
      return {
        ...state,
        editingUser: action.user,
      };

    default:
      return state;
  }
};

export default editUser;
